import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var LinkBreakIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M13.83 11.387A1 1 0 1112.17 12.5c-.75-1.122-2.197-1.74-3.51-1.412-2.04.507-5.66 4.113-5.66 6.334 0 2.16 1.482 3.35 3.683 3.57.945.094 2.383-.817 4.194-2.863a1 1 0 011.498 1.325c-2.2 2.485-4.123 3.704-5.89 3.528C3.366 22.672 1 20.77 1 17.422c0-3.257 4.325-7.565 7.175-8.275 2.16-.538 4.451.44 5.656 2.24zm6.224-6.22c2.389 1.593 3.372 4.215 1.84 7.28-1.526 3.051-7.806 5.102-10.613 4.303a1 1 0 11.548-1.923c1.95.555 7.222-1.167 8.276-3.275 1.039-2.078.45-3.646-1.16-4.72-.978-.652-2.469-.453-4.499.562a1 1 0 11-.894-1.789c2.606-1.303 4.77-1.592 6.502-.437zm-16.85.854l.112.03 3 1a1 1 0 01-.52 1.928l-.112-.03-3-1a1 1 0 01.52-1.928zm7.984-3.516a1 1 0 01.657 1.252l-1.03 3.304a1 1 0 01-1.909-.594l1.03-3.304a1 1 0 011.252-.658zM5.536 2.2a1 1 0 011.342.447l1.5 3a1 1 0 11-1.789.895l-1.5-3a1 1 0 01.447-1.342z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
LinkBreakIcon.isCarinaIcon = true;
export default LinkBreakIcon;
